import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { NavigationService } from 'src/app/core/service/navigation.service';
import { RESPONSE_CODE } from 'src/app/helper/class/app-constant';
import { UrlServices } from 'src/app/helper/class/url-services';
import { isEmptyObj, arrayGroupBy } from 'src/app/helper/class/utilityHelper';
import { pageInfo } from 'src/app/helper/interface/menu-interface';
import { ResponseData } from 'src/app/helper/interface/response';
import { AlertService } from 'src/app/helper/service/alert.service';
import { AuthService } from 'src/app/helper/service/auth.service';
import { MasterApiService } from 'src/app/modules/master/service/master-api.service';
import { FormGeneratorComponent } from 'src/app/shared/form/component/form-generator/form-generator.component';
import { USER_FORM, USER_DYNAMIC_VALIDATOR, PROFILE_FORM } from '../../helper/user_form';
import { groupModule } from '../../page/role-permission/role-permission.component';
import { UserApiService } from '../../services/user-api.service';
import { ModalService } from 'src/app/shared/service/modal.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent implements OnInit {
  userFormData = PROFILE_FORM
  urlService = UrlServices.PAGE_URL;
  roleRequired: boolean = false;
  module: groupModule = {};
  moduleArray: any = [];
  loading: boolean = false;
  userData: any = {};
  emailCheckingloader: boolean = false;
  data: any = {};
  submitted: boolean = false;
  isModal: boolean = false;
  tblRole: Array<any> = [];
  public onClose: Subject<boolean> = new Subject();
  userService: any;
  userId: any;
  pageInfo: pageInfo = { title: 'New User' }
  @ViewChild('basicForm') basicForm !: FormGeneratorComponent

  constructor(private userApi: UserApiService,
    private masterApi: MasterApiService,
    private auth: AuthService,
    private navigation: NavigationService,
    private activatedRoute: ActivatedRoute,
    private modalService: ModalService,
    private alertService: AlertService) { }

  ngOnInit(): void {
    this.userId = this.activatedRoute.snapshot.queryParams.id || '';
    this.pageInfo = {
      title: 'User Detail',
    }
    if (this.userId) {
      this.getUserData();
    }
    this.getData();
  }

  getData(tbl: any = 'module') {
    this.masterApi.getFullData(tbl, []).then(async (res: ResponseData | any) => {
      if (res.statusCode == 200) {
        if (tbl == 'module') {
          this.convertModuleArray(res.result);
        }
      }
    });
  }

  onChange(e: any) { }
  setInput(data: any) {
    this.data = data;
    this.isModal = true
    this.userData = this.auth.currentUserValue;
    this.applyFormvalue()
    this.getUserData();
  }





  applyFormvalue() {
    if (!isEmptyObj(this.userData)) {
      const patch = this.userData;
      // patch.role_id = "";
      this.basicForm.setData(patch);
    }
  }

  getUserData() {
    if (this.userId) {
      this.userApi.getUserData(this.userId).then((res: ResponseData | any) => {
        if (res.statusCode == RESPONSE_CODE.SUCCESS) {
          this.userData = res.result;
          if (this.userData.role) {
            this.tblRole = this.userData.role;
          }
          this.applyFormvalue()
        }
      })
    }
  }



  convertModuleArray(data: any) {
    this.moduleArray = data.map((a: any) => a.controlName = a.moduleName + '-' + a.actionName);
    const formGroup = arrayGroupBy(data, (a: any) => a.moduleName);
    this.module = formGroup;
  }

  mapModuleWithRole(role: Array<any>) {
    if (!isEmptyObj(this.module)) {
      if (isEmptyObj(this.moduleArray)) {
        this.convertModuleArray(this.module);
      }
      const roleId = role.map((a: any) => a.role_id)
        .filter((v: any, i: any, self: any) => self.indexOf(v) === i);
      Object.keys(this.module).map((a: any) => {
        this.module[a].map((b: any) => {
          const s = role.filter((f: any) => f.action_id == b.action_id && f.module_id == b.module_id) || []
          if (s.length) {
            b.checked = true;
          } else {
            b.checked = false;
          }
        })
      })
    }
  }



  close() {
    this.modalService.close()
  }

  apiPayload() {
    const payload: any = this.basicForm.apiPayload();
    // payload['role'] = this.tblRole;
    if (this.userData.user_id) {
      payload['id'] = this.userData.id;
      payload['user_id'] = this.userData.user_id;
    }
    return payload;
  }
  get isFormValid() {
    return this.basicForm?.isValid();
  }
  saveData() {
    this.submitted = true;
    if (this.basicForm.isValid()) {
      this.loading = true;
      this.userApi.saveUser(this.apiPayload()).then((res: ResponseData | any) => {
        if (res.statusCode == RESPONSE_CODE.SUCCESS) {
          this.alertService.showToast('User details has been saved..', 'success');
          this.close();
        } else {
          this.alertService.showToast('', 'error');
        }
      }).finally(() => {
        this.loading = false;
      })
    } else {
      this.alertService.showToast('form not valid', 'warn');
    }
  }
}